import React, { useMemo, useState } from "react";

import { getIn } from "formik";
import {
  TextField,
  Dialog,
  InputAdornment,
  IconButton,
  DialogActions,
  Button,
} from "@material-ui/core";
import DateIcon from "@material-ui/icons/DateRange";
import { Calendar, utils } from "react-modern-calendar-datepicker";
import {
  getTimeFormat,
  toGregorianDate,
  toJalaali,
} from "../../../helpers/date-helpers";
import { zeroPad } from "../../../helpers";
import CloseIcon from "@material-ui/icons/Close";

function DatePicker(props) {
  const {
    form: { errors, setFieldValue = () => {}, submitCount } = {},
    field: { name, value: _value } = {},
    disabled,
    birthDate,
    label,
    onChange,
    clearable,
    time,
    ...other
  } = props;
  const value = useMemo(() => {
    if (!_value || _value instanceof Date) return _value;
    return new Date(_value);
  }, [_value]);

  const birthDateRange = useMemo(() => {
    const { year, ...other } = utils("fa").getToday();
    return {
      minimumDate: { ...other, year: year - 100 },
      maximumDate: { ...other, year: year - 15 },
      defaultDate: { ...other, year: year - 27 },
    };
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const [objectValue, setObjectValue] = useState(() => {
    if (value) return toJalaali(value);
    if (birthDate) return birthDateRange.defaultDate;
  });
  const [timeValue, setTimeValue] = useState(() => {
    return getTimeFormat(value ? new Date(value) : undefined);
  });

  const valueText = useMemo(() => {
    if (!value) return "";
    const v = toJalaali(value);

    const text = `${v.year}/${zeroPad(v.month)}/${zeroPad(v.day)}`;
    if (!time) return text;
    return `${text} ${timeValue}`;
  }, [value, timeValue, time]);

  const setValue = (value) => {
    setFieldValue(name, value);
  };

  const handleConfirm = () => {
    const [hours, minutes] = timeValue?.split(":") || [0, 0];
    setValue(toGregorianDate(objectValue, hours, minutes));
    setIsOpen(false);
  };
  const handleChange = (v) => {
    if (onChange) onChange(v);
    setObjectValue(v);
  };
  const clear = (e) => {
    e?.stopPropagation();
    setValue(undefined);
  };
  const errorText = getIn(errors, name);
  const hasError = Boolean(errorText && submitCount);
  return (
    <>
      <TextField
        error={hasError}
        helperText={hasError ? errorText : ""}
        onClick={() => setIsOpen(true)}
        margin="normal"
        label={label}
        fullWidth
        value={valueText}
        inputProps={{ className: "en text-center", disabled: true }}
        variant="outlined"
        disabled={disabled}
        InputProps={{
          // inputComponent: DateInput,
          endAdornment: (
            <InputAdornment position="end">
              {clearable && value ? (
                <IconButton disabled={disabled} onClick={clear}>
                  <CloseIcon />
                </IconButton>
              ) : (
                <IconButton disabled={disabled} onClick={() => setIsOpen(true)}>
                  <DateIcon />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
      />
      <Dialog open={isOpen && !disabled}>
        <Calendar
          {...other}
          value={objectValue}
          locale="fa"
          {...(birthDate ? birthDateRange : {})}
          onChange={handleChange}
          shouldHighlightWeekends
          renderFooter={() => (
            <>
              {time && (
                <div className="d-flex justify-content-center">
                  <TextField
                    value={timeValue}
                    onChange={(e) => setTimeValue(e.target.value)}
                    type="time"
                  />
                </div>
              )}
              <DialogActions>
                <Button onClick={() => setIsOpen(false)} color="primary">
                  لغو
                </Button>
                <Button onClick={handleConfirm} color="primary">
                  ذخیره
                </Button>
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
}

export default DatePicker;
